import React, { useEffect } from 'react'
import { AccordionContainer } from '../accordion/accordion.module';
import { InputContainer } from '../form/form.module';
import storePersist from '../../../redux/storePersist';
import { useSelector } from 'react-redux';
import { selectStoresListItems } from '../../../redux/stores/selector';
import { selectWarehousesListItems } from '../../../redux/ware-houses/selector';
import { useAppDispatch } from '../../../hooks/hooks';
import { stores } from '../../../redux/stores/action';
import { warehouses } from '../../../redux/ware-houses/action';
import { channel } from '../../../redux/channel/action';
import { selectChannelListItems } from '../../../redux/channel/selector';

export default function IncludeComponent({ isSaleChannel, isCustomerTag, isCustomer, isStore, isWarehouse, isState, isCountry, isProduct, isCategory, products, handleInnerFormChange, categories, selectedInclude, customers, allTags }: any) {
  const dispatch = useAppDispatch()
  const countries = storePersist.get('countries').current?.items
  const states = storePersist.get('states').current?.items
  const channelItems = useSelector(selectChannelListItems)
  const storeLists = useSelector(selectStoresListItems)
  const warehouseListss = useSelector(selectWarehousesListItems)
  useEffect(() => {
    dispatch(stores.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/stores/list`, entity: 'stores', jsonData: {

      }
    })).then(() => {
      dispatch(warehouses.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/ware-houses/list`, entity: 'stores', jsonData: {

        }
      })).then(() => {
        dispatch(channel.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/organization-management/channels/list`, entity: 'channels', jsonData: {} }))
      })
    })
  }, [])


  return (
    <>

      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            {isCountry ?
              <div>
                <InputContainer
                  label="Countries"
                  labelField="Name"
                  list={countries}
                  onValueChange={(newValue: any) => {
                    const countryData: any = newValue.map((option: any) => option?.value || '')
                    handleInnerFormChange({
                      value: countryData,
                      field: 'Inclusions.CountryIds',
                      data: selectedInclude?.Inclusions
                    });
                  }}
                  type="multiselect"
                  valueField="Id"
                  value={selectedInclude?.Inclusions?.CountryIds}
                />

              </div>
              : null}
            {isState ?
              <div>
                <InputContainer
                  label="States"
                  labelField="Name"
                  list={states}
                  onValueChange={(newValue: any) => {
                    const stateData: any = newValue.map((option: any) => option?.value || '')

                    handleInnerFormChange({
                      value: stateData,
                      field: 'Inclusions.StateIds',
                      data: selectedInclude?.Inclusions
                    });
                  }}
                  type="multiselect"
                  valueField="Id"
                  value={selectedInclude?.Inclusions?.StateIds}
                />

              </div>
              : null}
            {isWarehouse ?
              <div>
                <InputContainer
                  label="Warehouse Name"
                  labelField="WarehouseInfo.WarehouseName"
                  list={warehouseListss?.result?.items}
                  onValueChange={(newValue: any | null) => {
                    const warehouseData: any = newValue.map((option: any) => option?.value || '')

                    handleInnerFormChange({
                      value: warehouseData,
                      field: 'Inclusions.WarehouseIds',
                      data: selectedInclude?.Inclusions
                    });
                  }}
                  type="multiselect"
                  valueField="WarehouseInfo.Id"
                  value={selectedInclude?.Inclusions?.WarehouseIds}
                />

              </div>
              : null}
            {isStore ?
              <div>
                <InputContainer
                  label="Store Name"
                  labelField="StoreName"
                  list={storeLists?.result?.items}
                  onValueChange={(newValue: any) => {
                    const storeData: any = newValue.map((option: any) => option?.value || '')

                    handleInnerFormChange({
                      value: storeData,
                      field: 'Inclusions.StoreIds',
                      data: selectedInclude?.Inclusions
                    });
                  }}
                  type="multiselect"
                  valueField="Id"
                  value={selectedInclude?.Inclusions?.StoreIds}
                />

              </div>
              : null}
            {isCustomer ?
              <div>
                <InputContainer
                  label="Customer Name"
                  labelField="AccountName"
                  list={customers}
                  onValueChange={(newValue: any | null) => {
                    const customerData: any = newValue.map((option: any) => option?.value || '')

                    handleInnerFormChange({
                      value: customerData,
                      field: 'Inclusions.CustomerIds',
                      data: selectedInclude?.Inclusions
                    });
                  }}
                  type="multiselect"
                  valueField="Id"
                  value={selectedInclude?.Inclusions?.CustomerIds}

                />

              </div>
              : null}
            {isCustomerTag ?
              <div>
                <InputContainer
                  label="Customer Tag"
                  labelField="displayText"
                  list={allTags}
                  onValueChange={(newValue: any | null) => {
                    const customerTagData: any = newValue.map((option: any) => option?.value || '')

                    handleInnerFormChange({
                      value: customerTagData,
                      field: 'Inclusions.CustomerTagIds',
                      data: selectedInclude?.Inclusions
                    });
                  }}
                  type="multiselect"
                  valueField="ValueId"
                  value={selectedInclude?.Inclusions?.CustomerTagIds}
                />

              </div>
              : null}
            {isSaleChannel ?
              <div>
                <InputContainer
                  label="Sales Channel"
                  labelField="SalesChannelName"
                  list={channelItems?.result?.items}
                  onValueChange={(newValue: any) => {
                    const channelData: any = newValue.map((option: any) => option?.value || '')

                    handleInnerFormChange({
                      value: channelData,
                      field: 'Inclusions.SalesChannelIds',
                      data: selectedInclude?.Inclusions
                    });
                  }}
                  type="multiselect"
                  valueField="Id"
                  value={selectedInclude?.Inclusions?.SalesChannelIds}
                />

              </div>
              : null}
            {isCategory ?
              <div>
                <InputContainer
                  label="Categorys"
                  labelField="CategoryName"
                  list={categories}
                  onValueChange={(newValue: any) => {
                    const channelData: any = newValue.map((option: any) => option?.value)

                    handleInnerFormChange({
                      value: channelData,
                      field: 'Inclusions.CategoryIds',
                      data: selectedInclude?.Inclusions
                    });
                  }}
                  type="multiselect"
                  valueField="Id"
                  value={selectedInclude?.Inclusions?.CategoryIds}
                />

              </div>
              : null}
            {isProduct ?
              <div>
                <InputContainer
                  label="Products"
                  labelField="Name"
                  list={products}
                  onValueChange={(newValue: any) => {
                    const channelData: any = newValue.map((option: any) => option?.value)

                    handleInnerFormChange({
                      value: channelData,
                      field: 'Inclusions.ProductIds',
                      data: selectedInclude?.Inclusions
                    });
                  }}
                  type="multiselect"
                  valueField="Id"
                  value={selectedInclude?.Inclusions?.ProductIds}
                />

              </div>
              : null}
          </div>}
        expandedPanel="inclusionsInfo"
        headerTitle="Inclusions Information" />
    </>
  )
}